// 設定保存を中断したことを伝えるモーダルを開くサービス。
// 「設定 > 家庭からの連絡」（旧世代の controller）と「設定 > 園情報設定」の両方から開くため DI に載せる。
angular.module('inspinia').factory('serviceSettingSaveBlockedModalService', function ($modal) {
  return {
    /**
     * モーダルを開く
     * @returns {Promise<void>} 「設定に戻る」で閉じられたら解決する
     */
    open: function () {
      // 呼び出し元のデータを使わないため scope は渡さない
      return $modal.open({
        templateUrl: 'views/services/include/service_setting_save_blocked_modal.html',
        windowClass: 'serviceSettingSaveBlockedModal codmonDialog codmonDialog--medium',
        // 「設定に戻る」以外で閉じないよう、背景クリックと Esc を両方無効にする
        backdrop: 'static',
        keyboard: false,
      }).result;
    },
  };
});
